import { YWT_PUBLIC_CONFIG } from '@cuspar/ywt.ch.config/public';
import { wrapAxios } from '../../axios';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

const checkStatus = () => wrapAxios<{ status: boolean }>(() => axios.get(`/status`));

export const StatusChecker = () => {
  const { t } = useTranslation();
  const [normal, setNormal] = useState<boolean>(true);
  useEffect(() => {
    checkSiteStatus();
  }, []);

  const checkSiteStatus = async () => {
    const response = await checkStatus();
    if (response.success) {
      setNormal(response.data.status);
    } else {
      setNormal(false);
    }
  };

  if (normal)
    return (
      <Link to={YWT_PUBLIC_CONFIG.statusUrl} target='_blank' className='text-green-600 text-sm font-medium'>
        {t('common.allSystemsNormal')}
      </Link>
    );

  return (
    <Link to={YWT_PUBLIC_CONFIG.statusUrl} target='_blank' className='text-yellow-600 text-sm font-medium'>
      {t('common.systemNotNormal')}
    </Link>
  );
};
